<template>
    <div class="af-jobview-share-btns afu-flex afu-gap-3 afu-items-center">
        <a
            href="#"
            class="af-btn-share-job afu-p-2 afu-text-xl"
            @click="toggle"
        >
            <FontAwesomeIcon
                :icon="['far', 'share-alt']"
                :class="['afu-text-primary-dark']"
            />
        </a>
        <div
            v-if="shareModalOpen"
            class="af-share-items-mobile afu-fixed afu-inset-x-0 afu-bg-neutral-light afu-py-4 afu-px-6"
        >
            <div
                class="afu-flex afu-items-center afu-gap-4"
            >
                <div class="afu-w-full afu-text-left afu-text-xl">
                    <FontAwesomeIcon
                        :icon="['far', 'share-alt']"
                        class="afu-w-5 afu-text-primary-dark svg-inline--fa fa-w-14 afu-mr-2"
                    /> <span class="afu-text-xl afu-leading-6xl">{{ $t('label.share') }}</span>
                </div>

                <ShareNetwork
                    v-for="network in networks"
                    :network="network.network"
                    :key="network.network"
                    :url="sharing.url"
                    :title="sharing.title"
                    :description="sharing.description"
                >
                    <div :class="`af-share-item af-share-${network.network} afu-content-center`">
                        <a
                            href="#"
                            class="afu-text-2xl"
                            :title="network.name"
                        >
                            <template>
                                <FontAwesomeIcon
                                    :icon="network.icon"
                                    class="afu-w-5 afu-text-secondary svg-inline--fa"
                                />
                            </template>
                        </a>
                    </div>
                </ShareNetwork>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { ShareNetwork } from 'vue-social-sharing';
    // import C1Button from '@/components/C1Components/C1Button';
    // import C1Modal from '@/components/C1Components/C1Modal';

    export default {
        name: 'ShareJobMobile',

        components: {
            ShareNetwork,
            // C1Button,
            // C1Modal,
        },

        data() {
            return {
                sharing: {
                    url: window.location.href,
                    title: '',
                    description: '',
                },
                networks: [
                    {
                        network: 'facebook',
                        name: 'Facebook',
                        icon: ['fab', 'square-facebook'],
                        shareText: 'Post',
                    },
                    {
                        network: 'twitter',
                        name: 'Twitter',
                        icon: ['fab', 'square-x-twitter'],
                        shareText: 'Tweet',
                    },
                    {
                        network: 'linkedin',
                        name: 'LinkedIn',
                        icon: ['fab', 'linkedin'],
                        shareText: 'Share',
                    },
                ],
                shareModalOpen: false,
            };
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),

            ...mapGetters('job', {
                $_jobTitle: 'jobTitle',
                $_jobBody: 'jobBody',
            }),
        },

        created() {
            this.sharing.title = this.$_jobTitle;
            this.sharing.description = this.$_jobBody;
        },

        methods: {
            sendEmail() {
                const subject = `Check out this job I found - ${this.sharing.title}`;
                let message = 'Hi [FRIEND NAME],\r\n';
                message += '\r\nCheck out this job that I found.\r\n';
                message += `\r\n${this.sharing.title}\r\n`;
                message += `\r\n${window.location.href}\r\n\r\n\r\n`;
                message += '[MESSAGE TO FRIEND]\r\n\r\n';
                message += '\r\nKind regards,\r\n[SENDER NAME]';
                window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
            },

            toggle() {
                if (!this.shareModalOpen) {
                    this.shareModalOpen = true;
                } else {
                    this.shareModalOpen = false;
                }
            },
        },
    };
</script>
<style>
    .af-share-items-mobile {
        bottom: 84px;
    }
</style>